<template>
  <VAppBar color="primary" dark style="position: fixed;">
    <!-- LOGO (Desktop) -->
    <div class="d-none d-lg-block">
      <div class="d-flex align-center">
        <VImg
          class="shrink mr-2"
          :src="favicon28"
          width="40"
          @click="$router.push('/')"
          style="cursor: pointer;"
        />
      </div>
    </div>

    <VSpacer class="d-none d-lg-block" />

    <VTabs class="d-none d-lg-block ml-auto" v-if="!terms">
      <VTab @click="menuTab = 'who_we_are'">{{ $t('MENU.who_we_are') }}</VTab>
      <VTab @click="menuTab = 'advantages'">{{ $t('MENU.advantages') }}</VTab>
      <VTab @click="menuTab = 'subscriptions'">{{ $t('MENU.subscription') }}</VTab>
      <VTab id="contact" @click="registerContactEvent(); menuTab = 'contacts'">{{ $t('MENU.contact') }}</VTab>
      <VTab @click="menuTab = 'blog'">{{ $t('MENU.blog') }}</VTab>
    </VTabs>

    <div class="mr-2 ml-4 d-none d-lg-block" style="justify-content:center;align-items:center;display:flex;">
      <VBtn @click="openReportlake" class="font-weight-light text-white elevation-16" rounded variant="outlined">
        {{ $t('MENU.login') }}
      </VBtn>
    </div>

    <!-- Idiomas Desktop -->
    <div class="d-none d-lg-block">
      <VMenu location="bottom">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            rounded="pill"
            variant="text"
            class="flag-btn"
          >
            <span class="fi fis" :class="'fi-' + chooseLanguage()" style="width: 24px !important;"></span>
          </v-btn>
        </template>

        <VList>
          <VListItem>
            <VListItemTitle>
              <VBtn rounded="pill" variant="text" class="flag-btn" @click="switchLocale('pt')">
                <span class="fi fis fi-pt" style="width: 24px !important;"></span>
              </VBtn>
            </VListItemTitle>
          </VListItem>

          <VListItem>
            <VListItemTitle>
              <VBtn rounded="pill" variant="text" class="flag-btn" @click="switchLocale('en')">
                <span class="fi fis fi-gb" style="width: 24px !important;"></span>
              </VBtn>
            </VListItemTitle>
          </VListItem>

          <VListItem>
            <VListItemTitle>
              <VBtn rounded="pill" variant="text" class="flag-btn" @click="switchLocale('it')">
                <span class="fi fis fi-it" style="width: 24px !important;"></span>
              </VBtn>
            </VListItemTitle>
          </VListItem>
        </VList>
      </VMenu>


    </div>

    <!-- MOBILE -->
    <VRow :class="showHeader ? 'd-md-none mt-4' : 'd-md-none'" style="width: 100%;">
      <VToolbar color="transparent">
        <div class="d-flex align-center">
          <VImg class="shrink ml-4" :src="favicon28" width="40" />
        </div>

        <VSpacer />

        <VScaleTransition>
          <VImg
            v-show="showHeader"
            style="margin:auto;display:block;"
            max-width="200px"
            :src="titleNegativo"
          />
        </VScaleTransition>

        <VSpacer />

        <VMenu location="bottom">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              rounded="pill"
              variant="text"
              class="flag-btn"
            >
              <span class="fi fis" :class="'fi-' + chooseLanguage()" style="width: 24px !important;"></span>
            </v-btn>
          </template>

          <VList>
            <VListItem>
              <VListItemTitle>
                <VBtn rounded="pill" variant="text" class="flag-btn" @click="switchLocale('pt')">
                  <span class="fi fis fi-pt" style="width: 24px !important;"></span>
                </VBtn>
              </VListItemTitle>
            </VListItem>

            <VListItem>
              <VListItemTitle>
                <VBtn rounded="pill" variant="text" class="flag-btn" @click="switchLocale('en')">
                  <span class="fi fis fi-gb" style="width: 24px !important;"></span>
                </VBtn>
              </VListItemTitle>
            </VListItem>

            <VListItem>
              <VListItemTitle>
                <VBtn rounded="pill" variant="text" class="flag-btn" @click="switchLocale('it')">
                  <span class="fi fis fi-it" style="width: 24px !important;"></span>
                </VBtn>
              </VListItemTitle>
            </VListItem>
          </VList>
        </VMenu>

        <VBtn icon class="mr-4" @click="$emit('openMenu')" v-if="$route.name !== 'Privacy'">
          <VIcon>mdi-menu</VIcon>
        </VBtn>
      </VToolbar>
    </VRow>
  </VAppBar>
</template>

<script>
import titleNegativo from '@/assets/icons/title_negativo.png'
import favicon28 from '@/assets/icons/fav/favicons-28.png'

export default {
  name: 'MenuDesktop',
  props: {
    terms: { type: Boolean, default: false }
  },
  data () {
    return {
      titleNegativo,
      favicon28,
      showHeader: false,
      menuTab: 'who_we_are'
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    openReportlake () {
      window.open('https://login.reportlake.com/', '_blank')
    },
    switchLocale (l) {
      this.$emit('switchLocale', l)
    },
    chooseLanguage () {
      return this.$i18n.locale === 'en' ? 'gb' : this.$i18n.locale
    },
    contactTab () {
      document.getElementById('contact')?.click()
    },
    registerContactEvent () {
      const cookie = this.$cookies.get('reportlake_website_cookie')
      if (!cookie || cookie.statistics === false) return
      this.$gtag?.event?.('contact_tag', {
        event_category: 'Contactos',
        event_label: 'Contactos',
        value: 'contact_tag'
      })
    },
    handleScroll () {
      this.showHeader = window.scrollY > 0
    }
  },
  watch: {
    menuTab: {
      immediate: true,
      handler (val) {
        if (val == null) return
        this.$emit('change', val)
      }
    }
  }
}
</script>

<style>
.v-btn__content{ width:fit-content; height:fit-content; }
.fi{ background-size:cover!important; line-height:1em!important; }
.fi.fis{ height:25%!important; width:100%!important; }
/* ajusta o diâmetro do botão icon */
/* controla tamanho do “chip” da bandeira */
.flag-btn{
  --v-btn-height: 40px;   /* altura do botão */
  min-width: 72px;        /* alarga horizontalmente (ajusta p.ex. 84/96) */
  padding-inline: 12px;   /* espaço lateral */
}

/* aumenta a própria bandeira (flag-icons escala por font-size) */
.flag-btn .fi{
  font-size: 15px;        /* 24–28 conforme preferires */
  line-height: 1;
}
</style>
